import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const ReportsWorkOrdersByVehicleList = lazyLoader(
  () =>
    import(
      "Containers/Reports/ReportsInnerPages/ReportsWorkOrdersByVehicle/ReportsWorkOrdersByVehicleList/ReportsWorkOrdersByVehicleList"
    )
);
export const ReportsWorkOrdersByVehicle = () => {
  return (
    <Layout>
      <ReportsWorkOrdersByVehicleList />
    </Layout>
  );
};
